var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKreLogoBig({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "35px",
    viewBox: "0 0 35 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Katalon Runtime Engine") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Get-Started",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3-Invite-users-to-your-organization",
    transform: "translate(-367.000000, -607.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17-Copy-2",
    transform: "translate(367.000000, 607.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-41-Copy-42",
    fill: "#9DCC3D",
    points: "9.9475983e-13 35 17.5 35 17.4937024 28.0092664 35 0 4.97379915e-13 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-41-Copy-11",
    fill: "#67B340",
    transform: "translate(20.810757, 21.297743) scale(-1, 1) translate(-20.810757, -21.297743) ",
    points: "6.62151426 35 28.4415112 35 35 24.3997176 23.6861328 7.59548611"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#67B340",
    cx: 15.4947917,
    cy: 17.5,
    r: 11.2413194
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9715856,6.81190504 C19.7799723,7.0745658 20.5382518,7.42013802 21.2400686,7.83614818 L21.2410908,9.72978234 L19.6608842,10.6766713 C19.1396732,10.3594145 18.5736356,10.0972187 17.9680553,9.90045374 C13.7692655,8.53618424 9.2595149,10.8340169 7.8952454,15.0328067 C6.53097591,19.2315965 8.8288086,23.7413471 13.0275984,25.1056166 C17.2263881,26.4698861 21.7361387,24.1720534 23.1004082,19.9732636 C24.0867161,16.9377202 23.1589659,13.7396479 20.9826332,11.6851162 L22.84437,8.99062314 C26.1653192,11.859227 27.6301081,16.5413868 26.1889569,20.9767939 C24.2704529,26.881342 17.9286162,30.1126692 12.0240681,28.1941653 C6.11951995,26.2756613 2.88819272,19.9338245 4.80669671,14.0292764 C6.72520069,8.12472828 13.0670374,4.89340106 18.9715856,6.81190504 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2413194,22.6892361 L11.2413194,12.3107639 L16.1913194,12.3107639 C18.4413194,12.3107639 20.0163194,13.8857639 20.0163194,15.9107639 C20.0163194,18.1607639 18.2163194,18.9857639 18.2163194,18.9857639 C19.1462338,20.6208583 19.8436696,21.8472472 20.3086268,22.6649306 C20.3270029,22.6972472 19.3265479,22.6972472 17.3072617,22.6649306 L15.4811694,19.5107639 L14.0913194,19.5107639 L14.0913194,22.6892361 L11.2413194,22.6892361 Z M17.1663194,15.9107639 C17.1663194,15.3107639 16.7163194,14.8607639 16.0413194,14.8607639 L14.0913194,14.8607639 L14.0913194,16.9607639 L16.0413194,16.9607639 C16.7163194,16.9607639 17.1663194,16.5107639 17.1663194,15.9107639 Z",
    id: "Rc",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKreLogoBig);
export default __webpack_public_path__ + "static/media/KRE_logo_big.e8b938ef3d2687df2dbf12fb20e11009.svg";
export { ForwardRef as ReactComponent };